import { TaskInstanceActionConfig, TaskInstanceActionContext } from "./types";
import { AchSendFormTaskAction } from "./AchSendFormTaskAction";
import { DestinationPacketTaskAction } from "./DestinationPacketTaskAction";

export const TASK_INSTANCE_ACTIONS: TaskInstanceActionConfig[] = [
  {
    id: "new-client-onboarding-ach",
    matcher: ({ taskTitle, templateName }) => {
      const normalizedTask = (taskTitle || "").trim().toLowerCase();
      const normalizedTemplate = (templateName || "").trim().toLowerCase();
      return /new client onboarding|non client onboarding/i.test(normalizedTemplate)&& /send out ach form|ach form sent/i.test(normalizedTask);
    },
    Component: AchSendFormTaskAction,
    description: "ACH review workflow",
  },
  {
    id: "new-destination-setup-envelope",
    matcher: ({ taskTitle, templateName }) => {
      const normalizedTask = (taskTitle || "").trim().toLowerCase();
      const normalizedTemplate = (templateName || "").trim().toLowerCase();
      return /new destination set up/i.test(normalizedTemplate) && /new destination form/i.test(normalizedTask);
    },
    Component: DestinationPacketTaskAction,
    description: "Destination envelope form",
  },
];

export function getTaskInstanceAction(context: TaskInstanceActionContext) {
  return TASK_INSTANCE_ACTIONS.find((config) => config.matcher(context));
}

export function hasTaskInstanceAction(context: TaskInstanceActionContext) {
  return !!getTaskInstanceAction(context);
}


